import type { Rsp } from "@repo/types";

/** 人脸验证失败后跳转的结果页参数：提示原因并引导用户重新开始 */
export function faceVerifyFailSearch(message: string) {
  return {
    title: "人脸验证未通过",
    message,
    op: "重新开始",
    redirect: "/help/account_recovery/menu",
  };
}

export interface FaceIdVerifyResult {
  code: number;
  result: string;
}

export function parseFaceIdVerifyResult(raw: unknown): FaceIdVerifyResult {
  const data = typeof raw === "string" ? JSON.parse(raw) : raw;
  return data as FaceIdVerifyResult;
}

export function getErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "msg" in err && typeof (err as Rsp<null>).msg === "string") {
    return (err as Rsp<null>).msg;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return "操作失败";
}
